import React from 'react';
function CallMade() {
    return (React.createElement("g", null,
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
        React.createElement("path", { d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" })));
}
export default CallMade;
